import { Component } from "react";
import { Alert, Button, Container, Table } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import "../../../assets/css/geral.scss";
import * as eventAction from "../../../actions/events/EventAction";

import { RouteComponentProps } from "react-router";
import ListEventState from "./ListEventState";
import { format } from "date-fns";
import Column from "../../../models/common/Column";
import EventCLusterDTO from "../../../models/EventClusterDTO";

class ListEvents extends Component<RouteComponentProps, ListEventState> {
  state: Readonly<ListEventState> = {
    clusters: new Array<EventCLusterDTO>(),
    email: "manual",
    account: "manual",
    region: "ALL",
    columns: [],
  };

  /*receiveMessageFromIndex(event) {
    var origin = event.origin || event.originalEvent.origin; // For Chrome, the origin property is in the event.originalEvent object.

    if (origin !== process.env.REACT_APP_ZINFI_URL) {
      
      return;
    }

    if (typeof event.data === 'object' && event.data.call === 'sendValue') {
      var userInfo = event.data.value;
      console.log('I am an iframe, I accepted it:', userInfo);
      this.setState({ email: userInfo.UserName });
      this.setState({ account: userInfo.AccountName });
    }
  };*/

  canYouHaveAccess() {
    try {
      if (
        process.env.REACT_APP_PROTECT_PAGE === "true" &&
        window.top?.location.host !== process.env.REACT_APP_ALLOW_API
      ) {
        console.log("You shall not pass");
        this.props.history.push("/not-found");
      }
    } catch (err) {}
  }

  componentDidMount() {
    this.canYouHaveAccess();
    this.getAllEvents();
    this.getColumns();

    //window.addEventListener("message", this.receiveMessageFromIndex.bind(this), false);
  }

  showEvents() {
    const { email } = this.state;
    return this.searchByRegion().map((e) => {
      const firstEvent = e.events[0];
      const lastEvent = e.events[e.events.length - 1];
      const type =
        firstEvent.eventLanguage?.toUpperCase() === "ENGLISH"
          ? firstEvent.description?.substr(
              0,
              firstEvent.description.indexOf("|")
            )
          : firstEvent.description?.substr(
              0,
              firstEvent.description.indexOf("in")
            );
      const stage =
        firstEvent.processStage === "REMOVE"
          ? "REMOVED-PROCESSED"
          : firstEvent.newStage;
      const isRemovedOrIsInProcessToBeRemoved =
        firstEvent.processStage !== "REMOVE" &&
        firstEvent.newStage !== "REMOVE";
      const isNotHot = firstEvent.type?.name !== "HOT";
      return (
        <tr key={e.id}>
          <td>
            {new Date(firstEvent.newDate || "").getDate() +
              " - " +
              format(new Date(lastEvent.newDate || ""), "dd MMM yyy") +
              " " +
              firstEvent.timezone +
              "( " +
              e.events.length +
              " days)"}
          </td>
          <td>{format(new Date(lastEvent.newDate || ""), "h:mm a")}</td>
          <td>
            <b>
              {stage +
                (e.isFull ? " - Full" : "") +
                (e.isClosed ? " - closed" : "")}
            </b>
          </td>
          <td>{firstEvent.type?.region}</td>
          <td>{firstEvent.eventLanguage}</td>
          <td>
            <a href={firstEvent.link}>{type}</a>
          </td>
          <td>
            {isRemovedOrIsInProcessToBeRemoved && isNotHot && !e.isClosed && (
              <Button
                className="mr-2 mb-2"
                variant="primary"
                onClick={() => this.fullOrNotFullEvent(!e.isFull, e.id)}
              >
                {e.isFull ? "Not Full" : "Full"}
              </Button>
            )}
            {/* {isRemovedOrIsInProcessToBeRemoved && <Button className="mr-2 mb-2" variant="primary" onClick={() => this.onUpdate(e.id)}>UPDATE</Button>} */}
            {isRemovedOrIsInProcessToBeRemoved &&
              !e.isClosed &&
              !e.isFull &&
              firstEvent.newStage !== "NEW" && (
                <Button
                  className="mb-2"
                  onClick={() => this.onDelete(email, false, e.id)}
                  variant="danger"
                >
                  REMOVE - Notify Partners
                </Button>
              )}
            {isRemovedOrIsInProcessToBeRemoved &&
              (!e.isClosed || firstEvent.newStage === "NOT_TO_PROCESS") &&
              !e.isFull && (
                <Button
                  onClick={() => this.onDelete(email, true, e.id)}
                  variant="danger"
                >
                  REMOVE - DO not Notify Partners
                </Button>
              )}
            {firstEvent.newStage === "REMOVE" && (
              <Button
                onClick={() => this.onCancelRemove(email, e.id)}
                variant="danger"
              >
                CANCEL REMOVE
              </Button>
            )}
          </td>
        </tr>
      );
    });
  }

  onDelete(updatedBy: string, doNotSendEmail: boolean, id?: number) {
    // const confirmation = true;
    const confirmation = window.confirm(
      "Are you sure you want to remove this event? If the event was already processed, partners will receive an email" +
        " confirming the cancellation of the event. If the event was not yet process, no email will be sent."
    );
    if (confirmation && id) {
      this.deleteEvent(id, updatedBy, doNotSendEmail);
    }
  }

  onCancelRemove(updatedBy: string, id?: number) {
    const confirmation = window.confirm(
      "Do you really want to cancel the remove action?"
    );
    if (confirmation && id) {
      this.cancelRemoveAction(id, updatedBy);
    }
  }

  onUpdate(id?: number) {
    this.props.history.push({
      pathname: "/add-event/" + id,
      state: { email: this.state.email, account: this.state.account },
    });
  }

  goToAddEvent() {
    this.props.history.push({
      pathname: "/add-event/0",
      state: { email: this.state.email, account: this.state.account },
    });
  }

  setSortedField(col: Column) {
    const { clusters, columns } = this.state;
    let newClusters: EventCLusterDTO[] = [];
    newClusters = col.isSorted ? clusters.reverse() : this.sortList(col.name);

    if (!col.isSorted) {
      let cols = columns;
      cols.forEach((c) => {
        if (c.name === col.name) {
          c.isSorted = true;
          return;
        }
        c.isSorted = false;
      });
      this.setState({ clusters: newClusters });
    }

    this.setState({ clusters: newClusters });
  }

  searchByRegion() {
    const { region, clusters } = this.state;
    return region === "ALL"
      ? clusters
      : clusters.filter((e) => e.events[0].type?.region === region);
  }

  render() {
    return (
      <>
        <Container className="mt-5 mb-4 ">
          <h1>
            TRAINING EVENTS{" "}
            <Button className="mb-3 ml-3" onClick={() => this.goToAddEvent()}>
              ADD EVENT
            </Button>
          </h1>
          <Button
            variant="info"
            className="mb-3 ml-3"
            onClick={() => this.setState({ region: "ALL" })}
          >
            ALL
          </Button>
          <Button
            variant="info"
            className="mb-3 ml-3"
            onClick={() => this.setState({ region: "NORAM" })}
          >
            NORAM
          </Button>
          <Button
            variant="info"
            className="mb-3 ml-3"
            onClick={() => this.setState({ region: "EMEA" })}
          >
            EMEA
          </Button>
          <Button
            variant="info"
            className="mb-3 ml-3"
            onClick={() => this.setState({ region: "LATAM" })}
          >
            LATAM
          </Button>
          <Button
            variant="info"
            className="mb-3 ml-3"
            onClick={() => this.setState({ region: "APAC" })}
          >
            APAC
          </Button>
        </Container>
        <Container className="mb-5">
          <Alert key="danger" variant="danger">
            UPDATE not working properly. Don't use it. Talk with gary.llil
          </Alert>
          <Table striped bordered hover responsive="sm">
            <thead>
              <tr>{this.showColumns()}</tr>
            </thead>
            <tbody>{this.showEvents()}</tbody>
          </Table>
        </Container>
      </>
    );
  }

  async getAllEvents() {
    eventAction
      .getAllEvents()
      .then((response) => {
        const clusters: Array<EventCLusterDTO> = response.data.sort(
          (a, b) =>
            new Date(b.events[0].newDate!).getTime() -
            new Date(a.events[0].newDate!).getTime()
        );
        this.setState({ clusters: clusters });
      })
      .catch((err) => {
        alert("loading events failed");
      });
  }

  async deleteEvent(id: number, updatedBy: string, doNotSendEmail: boolean) {
    eventAction
      .deleteEvent(updatedBy, id, doNotSendEmail)
      .then((response) => {
        alert("event removed with success.");
      })
      .then((Response) => this.getAllEvents())
      .catch((err) => {
        alert("event not removed. Something went wrong");
      });
  }

  async cancelRemoveAction(id: number, updatedBy: string) {
    eventAction
      .cancelRemoveAction(updatedBy, id)
      .then((response) => {
        alert("remove cancellation work with success");
      })
      .then((Response) => this.getAllEvents())
      .catch((err) => {
        alert("Something went wrong");
      });
  }

  async fullOrNotFullEvent(isFull: boolean, id?: number) {
    eventAction
      .fullOrNotFullEvent(isFull, id)
      .then((response) => {
        alert("isFull= " + isFull);
      })
      .then((Response) => this.getAllEvents())
      .catch((err) => {
        alert("Something went wrong");
      });
  }

  getColumns() {
    const dateColumn = new Column("Date", true);
    const timeColumn = new Column("Time", false);
    const stageColumn = new Column("Stage", false);
    const regionColumn = new Column("Region", false);
    const languageColumn = new Column("Language", false);
    const typeColumn = new Column("Type", false);
    const actionColumn = new Column("Action", false);
    let columns = [
      dateColumn,
      timeColumn,
      stageColumn,
      regionColumn,
      languageColumn,
      typeColumn,
      actionColumn,
    ];
    this.setState({ columns: columns });
  }

  showColumns() {
    const { columns } = this.state;
    return columns.map((c) => {
      const classNameValue =
        ["Action", "Time"].find((l) => l === c.name) !== undefined
          ? ""
          : "table-col";
      return (
        <th
          className={classNameValue}
          key={c.name}
          onClick={() => this.setSortedField(c)}
        >
          {c.name}
        </th>
      );
    });
  }

  sortList(name: string) {
    const { clusters } = this.state;
    if (name === "Date") {
      return clusters.sort(
        (a, b) =>
          new Date(b.events[0].newDate!).getTime() -
          new Date(a.events[0].newDate!).getTime()
      );
    }

    if (name === "Region") {
      return clusters.sort(
        (a, b) =>
          a.events[0].type?.region!.localeCompare(b.events[0].type?.region!) ||
          0
      );
    }

    if (name === "Language") {
      return clusters.sort(
        (a, b) =>
          a.events[0].eventLanguage!.localeCompare(
            b.events[0].eventLanguage!
          ) || 0
      );
    }

    if (name === "Stage") {
      return clusters.sort(
        (a, b) =>
          a.events[0].newStage!.localeCompare(b.events[0].newStage!) || 0
      );
    }

    if (name === "Type") {
      return clusters.sort(
        (a, b) =>
          a.events[0].type?.name!.localeCompare(b.events[0].type?.name!) || 0
      );
    }
    return clusters;
  }
}

export default withRouter(ListEvents);
